import React, { Component } from 'react'
import { Dropdown, ButtonGroup, Button } from 'react-bootstrap';

import { Http } from '../../../support';
import LoadingButton from '../../../facturotopia/LoadingButton';
import PopConfirm from '../../../facturotopia/popconfirm/PopConfirm';

class ComprobantesDownloadItemActions extends Component {

  state = {
    showConfirm: false
  }

  handleOnCancelActionClick = () => {
    this.setState({
      showConfirm: true
    });
  }

  handleOnDownloadActionClick = async (kind) => {
    const { uuids } = this.props.data;

    this.setState({
      busy: true
    });

    try {
      const body = {
        type: kind || 'pdf',
        uuids,
        compras: true,
      }

      const response = await Http.post(`${window.BONJOUR_URL}/api/comprobantes/download`, body, { responseType: 'blob' });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar tus comprobantes'
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  handleOnAction = (action) => {

  }

  handleOnSentMailActionClick = async (kind) => {
    const { id } = this.props.data;

    this.setState({
      sent: true
    });

    try {
      const response = await Http.put(`api/compras/${id}/sent`)

      window.ToastManager.show({
        variant: 'mail',
        title: 'Email',
        message: response?.message || 'Factura enviada a tu correo.'
      });
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'Falla envío de correo.'
      });
    } finally {
      this.setState({
        sent: false
      });
    }
  }

  render() {
    const { showConfirm, busy, sent } = this.state;
    const { alignRight } = this.props;

    if (!!busy) {
      return (
        <LoadingButton type="button"
          variant="transparent"
          loading={ busy }
        >
          Descargando
        </LoadingButton>
      );
    }

    if (!!sent) {
      return (
        <LoadingButton type="button"
          variant="transparent"
          loading={ sent }
        >
          Enviando
        </LoadingButton>
      );
    }

    return (
      <>
        { showConfirm &&
          (
            <PopConfirm variant="inline" text="Realmente deseas cancelar?"
              onAction={ this.handleOnAction }
            />
          )
        }

        { !showConfirm &&
          (
            <Dropdown as={ ButtonGroup } alignRight={ alignRight }>
              <Button variant="secondary"
                onClick={ this.handleOnDownloadActionClick.bind(this, 'zip') }
              >
                Descargar facturas
              </Button>

              <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic" />

              <Dropdown.Menu>
                <Dropdown.Item as="div" onClick={ this.handleOnSentMailActionClick.bind(this, 'sent') }>
                  Enviar por email
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )
        }
      </>

    )
  }
}

export default ComprobantesDownloadItemActions;